import React from 'react';
import { FormattedMessage } from 'react-intl';
import { ConfirmationDialog } from 'acscp/components/common/confirmationDialog';

interface AddAccountLinkConfirmationDialogProps {
    isOpen: boolean;
    email: string;
    closeDialog: () => void;
    addAccountLink: () => void;
}

const AddAccountLinkConfirmationDialog: React.SFC<AddAccountLinkConfirmationDialogProps> =
    ({isOpen, email, closeDialog, addAccountLink}) => (
        <ConfirmationDialog
            isOpen={isOpen}
            closeDialog={closeDialog}
            modalHeaderContent={
                <FormattedMessage
                    id={'components.accountLinks.addAccountLinkDialog.header'}
                    defaultMessage={'Add account link'}
                />
            }
            confirmationContent={
                <div>
                    <FormattedMessage
                        id={'components.accountLinks.addAccountLinkDialog.content'}
                        defaultMessage={
                            'Please confirm that you’d like to share all future flight details with the following email address: ' +
                            '{emailAddress}'
                        }
                        values={{emailAddress: email}}
                    />
                </div>
            }
            leftButtonContent={
                <FormattedMessage
                        id={'components.accountLinks.addAccountLinkDialog.yes'}
                        defaultMessage={'Yes'}
                />
            }
            leftButtonGreyedOut={false}
            leftButtonOnClick={() => {
                addAccountLink();
                closeDialog();
            }}
            rightButtonContent={
                <FormattedMessage
                        id={'components.accountLinks.addAccountLinkDialog.no'}
                        defaultMessage={'No'}
                />
            }
            rightButtonGreyedOut={true}
            rightButtonOnClick={closeDialog}
        />
    );

export { AddAccountLinkConfirmationDialog };
